import { ContractCheckout } from "../../classes";

const ContractCheckoutModule = {
  namespaced: true,
  state: {
    contractCheckout: {},
    checkouts: [],
    checkout: {}
  },
  actions: {
    async getContractCheckoutData({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.getContractCheckoutData(payload);
        commit("setContractCheckout", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async createContractCheckout({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.createContractCheckout({
          ...payload,
          items: payload?.invoice?.items
        });
        commit("setContractCheckout", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async sendContractCheckoutApproveTask({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.sendContractCheckoutApproveTask({
          ...payload,
          items: payload?.invoice?.items
        });
        commit("setContractCheckout", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async cancelDraftContractCheckout({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.cancelDraftContractCheckout({
          ...payload,
          items: payload?.invoice?.items
        });
        commit("setContractCheckout", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async getContractCheckoutsByContract(
      { commit, rootGetters, dispatch },
      payload
    ) {
      try {
        const data = await ContractCheckout.getContractCheckoutsByContract(
          payload
        );
        commit("setCheckouts", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async getContractCheckout({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.getContractCheckout(payload);
        commit("setContractCheckout", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async payContractCheckout({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.payContractCheckout(payload);
        dispatch("getContractCheckout", { id: payload.id });
        return data;
      } catch (e) {
        throw e;
      }
    },
    async successContractCheckout({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.successContractCheckout(payload);
        commit("setContractCheckout", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async getContractCheckoutsBetweenDateByMarket(
      { commit, rootGetters, dispatch },
      payload
    ) {
      try {
        const data = await ContractCheckout.getContractCheckoutsBetweenDateByMarket(
          payload
        );
        commit("setCheckouts", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async getContractCheckoutsStatusDateBetweenDateByMarket(
      { commit, rootGetters, dispatch },
      payload
    ) {
      try {
        const data = await ContractCheckout.getContractCheckoutsStatusDateBetweenDateByMarket(
          payload
        );
        commit("setCheckouts", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async updateContractCheckout({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.updateContractCheckout(payload);
        commit("setContractCheckout", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async getContractCheckoutByContractIds({ commit, rootGetters, dispatch }, payload) {
      try {
        const data = await ContractCheckout.getContractCheckoutByContractIds(payload);
        commit("setCheckouts", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
  },
  getters: {
    contractCheckout: state => state.contractCheckout,
    checkouts: state => state.checkouts,
    checkout: state => state.checkout
  },
  mutations: {
    setContractCheckout: (state, payload) => {
      state.contractCheckout = payload;
    },
    setContractCheckoutForfeit: (state, payload) => {
      let { isForfeit, modeForfeitSelect, forfeitCost, depositInvoices } = payload
      state.contractCheckout.isForfeit = isForfeit
      state.contractCheckout.modeForfeitSelect = modeForfeitSelect
      state.contractCheckout.forfeitCost = parseFloat(forfeitCost);
      state.contractCheckout.depositInvoices = depositInvoices
    },
    setCheckouts: (state, payload) => {
      state.checkouts = payload;
    },
    setCheckout: (state, payload) => {
      state.checkout = payload;
    }
  }
};

export default ContractCheckoutModule;
